import { IncidentDetailEmsTeam } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';
import { BorderedContainer } from '../../common/BorderedContainer';
import { SectionTitle } from '../../common/SectionTitle';

type Props = {
  /** 救急隊情報。 */
  emsTeam: IncidentDetailEmsTeam;
};

/** 救急隊編成のコンポーネント。 */
export const EmergencyTeam = ({ emsTeam }: Props) => {
  return (
    <div className="flex flex-col gap-[12px]">
      <SectionTitle text="救急隊編成" />
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <p className="text-[16px] noto-sans-jp-medium text-primary">
            {emsTeam.emsTeamName ?? ''}
          </p>
          <div className="flex flex-wrap gap-x-[40px] gap-y-[16px] xl:gap-x-[96px]">
            {emsTeam.emsTeamMembers.map((member, index) => (
              <div key={index} className="flex gap-[8px]">
                {member.position && (
                  <p className="text-[14px] noto-sans-jp-medium text-primary">
                    {member.position}
                  </p>
                )}
                {member.name && (
                  <p className="text-[14px] noto-sans-jp-medium text-textPrimary">
                    {member.name}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </BorderedContainer>
    </div>
  );
};
